import MapChart from "./SvgMap";
import {useEffect, useState} from "react";
import CountrySelector from "../CountrySelector/CountrySelector";

export default function Map(){

    const [isMob , setIsMob] = useState(false)
    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 480px)'); // Установите нужный вам медиа-запрос
        const handleResize = (event) => {
            setIsMob(event.matches);
        };
        mediaQuery.addListener(handleResize);
        setIsMob(mediaQuery.matches);
        return () => {
            mediaQuery.removeListener(handleResize);
        };
    }, [isMob]);

    const countryArray = [
        {name : 'Australia', isoCode: 'AU', price: '1400', conv: '10%'},
        {name : 'Austria', isoCode: 'AT', price: '1500', conv: '10%'},
        {name : 'Azerbaijan', isoCode: 'AZ', price: '800', conv: '4%'},
        {name : 'Argentina', isoCode: 'AR', price: '750', conv: '4%'},
        {name : 'Armenia', isoCode: 'AM', price: '800', conv: '5%'},
        {name : 'Bahrain', isoCode: 'BH', price: '1250', conv: '8%'},
        {name : 'Belarus', isoCode: 'BY', price: '800', conv: '5%'},
        {name : 'Belgium', isoCode: 'BE', price: '1300', conv: '10%'},
        {name : 'Bulgaria', isoCode: 'BG', price: '1000', conv: '6%'},
        {name : 'Brazil', isoCode: 'BR', price: '850', conv: '4%'},
        {name : 'United Kingdom', isoCode: 'GB', price: '1300', conv: '10%'},
        {name : 'Hungary', isoCode: 'HU', price: '1050', conv: '7%'},
        {name : 'Greece', isoCode: 'GR', price: '1000', conv: '6%'},
        {name : 'Georgia', isoCode: 'GE', price: '800', conv: '5%'},
        {name : 'Denmark', isoCode: 'DK', price: '1300', conv: '10%'},
        {name : 'India', isoCode: 'IN', price: '750', conv: '3%'},
        {name : 'Ireland', isoCode: 'IE', price: '1300', conv: '10%'},
        {name : 'Iceland', isoCode: 'IS', price: '1300', conv: '10%'},
        {name : 'Spain', isoCode: 'ES', price: '1200', conv: '8%'},
        {name : 'Italy', isoCode: 'IT', price: '1200', conv: '8%'},
        {name : 'Kazakhstan', isoCode: 'KZ', price: '750', conv: '4%'},
        {name : 'Canada', isoCode: 'CA', price: '1300', conv: '12%'},
        {name : 'Qatar', isoCode: 'QA', price: '1200', conv: '8%'},
        {name : 'Kyrgyzstan', isoCode: 'KG', price: '750', conv: '3%'},
        {name : 'China', isoCode: 'CN', price: '1200', conv: '10%'},
        {name : 'Colombia', isoCode: 'CO', price: '800', conv: '4%'},
        {name : 'Kuwait', isoCode: 'KW', price: '1200', conv: '8%'},
        {name : 'Latvia', isoCode: 'LV', price: '1200', conv: '7%'},
        {name : 'Lithuania', isoCode: 'LT', price: '1200', conv: '7%'},
        {name : 'Luxembourg', isoCode: 'LU', price: '1300', conv: '10%'},
        {name : 'Malaysia', isoCode: 'MY', price: '1200', conv: '8%'},
        {name : 'Malta', isoCode: 'MT', price: '1200', conv: '9%'},
        {name : 'Mexico', isoCode: 'MX', price: '800', conv: '3%'},
        {name : 'Moldova', isoCode: 'MD', price: '800', conv: '5%'},
        {name : 'Netherlands', isoCode: 'NL', price: '1200', conv: '10%'},
        {name : 'New Zealand', isoCode: 'NZ', price: '1300', conv: '10%'},
        {name : 'Norway', isoCode: 'NO', price: '1300', conv: '10%'},
        {name : 'Oman', isoCode: 'OM', price: '1200', conv: '4%'},
        {name : 'Peru', isoCode: 'PE', price: '700', conv: '3%'},
        {name : 'Poland', isoCode: 'PL', price: '1200', conv: '11%'},
        {name : 'Portugal', isoCode: 'PT', price: '1100', conv: '8%'},
        {name : 'Romania', isoCode: 'RO', price: '1000', conv: '6%'},
        {name : 'Saudi Arabia', isoCode: 'SA', price: '1100', conv: '4%'},
        {name : 'Serbia', isoCode: 'RS', price: '1000', conv: '7%'},
        {name : 'Singapore', isoCode: 'SG', price: '1300', conv: '9%'},
        {name : 'Slovakia', isoCode: 'SK', price: '1100', conv: '6%'},
        {name : 'Slovenia', isoCode: 'SI', price: '1100', conv: '8%'},
        {name : 'Tajikistan', isoCode: 'TJ', price: '750', conv: '3%'},
        {name : 'Thailand', isoCode: 'TH', price: '1200', conv: '4%'},
        {name : 'Turkey', isoCode: 'TR', price: '1000', conv: '6%'},
        {name : 'Uzbekistan', isoCode: 'UZ', price: '700', conv: '4%'},
        {name : 'Philippines', isoCode: 'PH', price: '750', conv: '3%'},
        {name : 'Finland', isoCode: 'FI', price: '1200', conv: '8%'},
        {name : 'France', isoCode: 'FR', price: '1200', conv: '8%'},
        {name : 'Croatia', isoCode: 'HR', price: '1000', conv: '7%'},
        {name : 'Czech Republic', isoCode: 'CZ', price: '1300', conv: '13%'},
        {name : 'Chile', isoCode: 'CL', price: '900', conv: '4%'},
        {name : 'Switzerland', isoCode: 'CH', price: '1300', conv: '12%'},
        {name : 'Sweden', isoCode: 'SE', price: '1300', conv: '10%'},
        {name : 'Estonia', isoCode: 'EE', price: '1200', conv: '9%'},
        {name : 'South Africa', isoCode: 'ZA', price: '800', conv: '3%'},
        {name : 'Japan', isoCode: 'JP', price: '1300', conv: '10%'},
        {name : 'Guatemala', isoCode: 'GT', price: '800', conv: '3%'},
        {name : 'Salvador', isoCode: 'SV', price: '800', conv: '3%'},
        {name : 'Panama', isoCode: 'PA', price: '800', conv: '3%'},
        {name : 'Ecuador', isoCode: 'EC', price: '800', conv: '3%'},
        {name : 'Uruguay', isoCode: 'UY', price: '800', conv: '3%'},
        {name : 'Indonesia', isoCode: 'ID', price: '900', conv: '4%'},
    ]

    let blackList = ['UA', 'US', 'IL', 'DE', 'AE'];

    return(
        <>
        {
        (isMob) ?   <CountrySelector countrysArray={countryArray}/>
            :
            <MapChart countrysArray={countryArray} blackList={blackList}/>
        }
        </>
    )

}